export default __webpack_public_path__ + "static/media/empty-checkbox.11a32d9d.svg";